import { createContext, useContext, type ReactNode } from 'react'

export type TableLinkVariant = 'default' | 'plain'

const TableLinkStyleContext = createContext<TableLinkVariant>('default')

export const useTableLinkVariant = () => useContext(TableLinkStyleContext)

/**
 * Opts a subtree into the DS2026 surface. Renders a transparent
 * (display: contents) wrapper with className "fb-plain-links" — main.css
 * keys off that class to restyle links, row states, header chrome, the
 * checkbox, and table toolbar. Components like PredictedTrafficBadge /
 * ExpenseCategoryBadge also read the React context to switch their JSX.
 */
export const TableLinkStyleProvider = ({
  variant,
  children,
}: {
  variant: TableLinkVariant
  children: ReactNode
}) => {
  if (variant !== 'plain') return <>{children}</>
  return (
    <TableLinkStyleContext.Provider value="plain">
      <div className="fb-plain-links contents">{children}</div>
    </TableLinkStyleContext.Provider>
  )
}
